function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import classes from './ecommerce-select.scss';
export const selectClasses = {
  root: classes.root
};
export const inputClasses = {
  root: classes.inputRoot
};
const menuProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  getContentAnchorEl: null
};
export const EcommerceSelect = _ref => {
  let {
      options = [],
      value,
      onChange,
      dataDropdown = '',
      placeholder
    } = _ref,
    rest = _objectWithoutProperties(_ref, ["options", "value", "onChange", "dataDropdown", "placeholder"]);
  const labelsByValue = options.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {});
  return /*#__PURE__*/React.createElement("div", {
    "data-dropdown": dataDropdown
  }, /*#__PURE__*/React.createElement("select", {
    value: value,
    onChange: e => {
      const {
        value
      } = e.target;
      onChange(e, null, value);
    },
    className: classes.select
  }, options.map(({
    value,
    label,
    key
  }) => /*#__PURE__*/React.createElement("option", {
    key: key || value,
    value: value
  }, label))), /*#__PURE__*/React.createElement(Select, _extends({
    MenuProps: menuProps,
    input: /*#__PURE__*/React.createElement(Input, {
      classes: inputClasses
    }),
    disableUnderline: true,
    displayEmpty: true,
    classes: selectClasses,
    variant: "filled",
    value: value === null ? '' : value,
    readOnly: !options[0],
    renderValue: selected => selected === '' || selected === undefined ? /*#__PURE__*/React.createElement("div", {
      className: classes.placeholder
    }, placeholder) : labelsByValue[selected],
    onChange: onChange
  }, rest), options.map(({
    value,
    label,
    key
  }) => /*#__PURE__*/React.createElement(MenuItem, {
    key: key || value,
    value: value
  }, label))));
};